import { httpClient } from "../../../shared/api";

export const productsApi = {
  list:   ()        => httpClient.get("/products"),
  create: (body)    => httpClient.post("/products", body),
  update: (id, body)=> httpClient.put(`/products/${id}`, body),
  delete: (id)      => httpClient.delete(`/products/${id}`),
};
